import { Dialog } from 'primereact/dialog'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { setSelectedDevice } from '../../../../redux/Slices/deviceSlice'
import { toggleDialog } from '../../../../redux/Slices/Global/globalSlice'

// Same stroke-icon family as DeviceCard's ⋮ menu — one per action this
// dialog can be opened for (.claude/pp-dialogs-prototype.html's plain
// confirm variant, e.g. its "إعادة تشغيل الشاشة" example).
const IcRestart = () => <svg viewBox="0 0 24 24"><path d="M21 12a9 9 0 1 1-3-6.7M21 4v5h-5" /></svg>;
const IcBinOutline = () => <svg viewBox="0 0 24 24"><path d="M4 7h16M9 7V5h6v2M6 7l1 13h10l1-13" /></svg>;
const IcSpeaker = () => <svg viewBox="0 0 24 24"><path d="M11 5 6 9H3v6h3l5 4zM16 9a4 4 0 0 1 0 6" /></svg>;
const IcSpeakerMute = () => <svg viewBox="0 0 24 24"><path d="M11 5 6 9H3v6h3l5 4z" /><path d="M15 9l5 6M20 9l-5 6" /></svg>;
const IcPlay = () => <svg viewBox="0 0 24 24"><path d="M7 5l12 7-12 7z" /></svg>;
const IcPause = () => <svg viewBox="0 0 24 24"><rect x="7" y="5" width="4" height="14" rx="1" /><rect x="14" y="5" width="4" height="14" rx="1" /></svg>;
const IcSearch = () => <svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="7" /><path d="M21 21l-4.3-4.3" /></svg>;
const IcLock = () => <svg viewBox="0 0 24 24"><rect x="5" y="11" width="14" height="9" rx="2" /><path d="M8 11V8a4 4 0 0 1 8 0v3" /></svg>;
const IcPower = () => <svg viewBox="0 0 24 24"><path d="M12 3v8" /><path d="M6.3 6.3a8 8 0 1 0 11.4 0" /></svg>;
const IcClose = () => <svg width="18" height="18" viewBox="0 0 24 24" style={{ stroke: 'currentColor', fill: 'none', strokeWidth: 2 }}><path d="M6 6l12 12M18 6L6 18" /></svg>;

const WarnActionDialog = ({ action, handleConfirm, isLoading }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch()
    const { openDialog } = useSelector((state) => state.global);
    const { selectedDevice } = useSelector((state) => state.device);

    const onClose = () => {
        dispatch(setSelectedDevice({}));
        dispatch(toggleDialog("warnActionDialog"))
    }

    const ICON = {
        flush: <IcBinOutline />, restart: <IcRestart />,
        mute: <IcSpeaker />, unmute: <IcSpeakerMute />,
        play: <IcPlay />, pause: <IcPause />,
        ai_analytics: <IcSearch />, reissue_token: <IcLock />, turn_off: <IcPower />,
    };

    const title = () => {
        if (action === "flush") return t('devices.group_flush');
        if (action === "restart") return t('devices.group_restart');
        if (action === "unmute") return t('devices.group_unmute');
        if (action === "mute") return t('devices.group_mute');
        if (action === "play") return t('devices.group_play');
        if (action === "pause") return t('buttons.pause');
        if (action === "ai_analytics") return t('devices.group_warn_ai_switch');
        if (action === "reissue_token") return t('devices.group_reissue_token');
        if (action === "turn_off") return t('devices.group_turn_off');
        return '';
    };

    const bodyPhrase = () => {
        if (action === "flush") return t('devices.group_flush');
        if (action === "restart") return t('devices.group_restart');
        if (action === "turn_off") return t('devices.group_turn_off');
        if (action === "unmute") return t('devices.group_unmute');
        if (action === "mute") return t('devices.group_mute');
        if (action === "play") return t('devices.group_play');
        if (action === "pause") return t('buttons.pause');
        if (action === "ai_analytics") return selectedDevice.ai_analytics ? t('devices.group_confirm_ai_off') : t('devices.group_confirm_ai_on');
        if (action === "reissue_token") return t('devices.group_confirm_reissue');
        return '';
    };

    const confirmDelete = () => handleConfirm();

    return (
        <Dialog
            id="assignDeviceDialog"
            visible={openDialog.warnActionDialog}
            breakpoints={{ '960px': '95vw' }}
            style={{ width: '420px' }}
            showHeader={false}
            modal className="pp-dlg"
            onHide={onClose}>

            <div className="pp-dlg-hd">
                <span className="ic">{ICON[action]}</span>
                <div><div className="t">{title()}</div></div>
                <span className="x" onClick={onClose}><IcClose /></span>
            </div>

            <div className="pp-dlg-bd">
                <p className="dlgtext">
                    {t('devices.group_are_you_sure')}&nbsp;{bodyPhrase()}&nbsp;
                    <b>{selectedDevice.name}</b>؟
                    {action === "reissue_token" && (
                        <span className="note d-block">{t('devices.group_reissue_token_note')}</span>
                    )}
                </p>
            </div>

            <div className="pp-dlg-ft">
                <button className="btn primary" disabled={isLoading} onClick={confirmDelete}>{t('buttons.yes')}</button>
                <button className="btn ghost" disabled={isLoading} onClick={onClose}>{t('buttons.no')}</button>
            </div>
        </Dialog>
    )
}

export default WarnActionDialog
